import React from 'react';
import type { TextInputProps } from './text-input';
import TextInput from './text-input';

interface NumberInputProps extends TextInputProps {
  min?: number;
  max?: number;
  step?: number;
}

const NumberInput = (props: NumberInputProps) => (
  <TextInput type="number" {...props} />
);

export default NumberInput;
